module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "signup-next"
  }, [_c('Icon'), _vm._v(" "), _c('el-collapse-transition', [(_vm.errorShow) ? _c('Error', {
    attrs: {
      "msg": _vm.errorMsg
    },
    on: {
      "closeErrorTip": _vm.closeErrorTip
    }
  }) : _vm._e()], 1), _vm._v(" "), _c('Account', {
    attrs: {
      "content": _vm.$route.query.account
    }
  }), _vm._v(" "), _c('Inputs', {
    attrs: {
      "type": 'newpassword'
    },
    on: {
      "inputText": _vm.getNewPassword,
      "enterInput": _vm.enterInput
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "button"
  }, [_c('Buttons', {
    staticStyle: {
      "width": "140px",
      "float": "left",
      "margin-top": "0"
    },
    attrs: {
      "type": 'back',
      "data": {
        type: _vm.type,
        username: _vm.name,
        password: _vm.newpassword,
        account: _vm.$route.query.account
      }
    }
  }), _vm._v(" "), _c('Buttons', {
    ref: "btn",
    staticStyle: {
      "width": "140px",
      "float": "right",
      "margin-top": "0"
    },
    attrs: {
      "type": _vm.isPhone ? 'done' : 'done',
      "data": {
        type: _vm.type,
        username: _vm.name,
        password: _vm.newpassword,
        account: _vm.$route.query.account
      }
    },
    on: {
      "openErrorTip": _vm.openErrorTip,
      "closeErrorTip": _vm.closeErrorTip
    }
  })], 1), _vm._v(" "), _vm._m(0)], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "foot"
  }, [_c('span', [_vm._v("By registering, you agree to the ")]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "https://www.craitapp.com/useragreement.php",
      "target": "_blank"
    }
  }, [_vm._v("User agreement")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-4ece1076"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/new-login-2018/login/Signupnext.vue
// module id = 773
// module chunks = 1